<template>
  <SfDropdown
    v-if="tags.length"
    dropdown-id="tagfilter"
    :drawer-direction="drawerDirections.left"
    :is-open="isScopedDropdownOpen"
    data-testid="remark-tag-filter"
    @dropdown-clicked="handleToggleDropdown"
  >
    <template #trigger>
      {{ triggerText }}
    </template>

    <template #menu>
      <div
        class="sf-tab-item"
        :class="showAllActiveClass"
        @click.stop="clearTagSelection"
      >
        {{ I18n.t('companies_overview.filters.comparison_modes.any') }}
      </div>
      <div
        v-for="tag in effectiveTags"
        :key="tag.id"
        class="sf-tab-item"
        :class="tag.activeClass"
        @click.stop="tagSelected(tag)"
      >
        <span class="tw-whitespace-nowrap">
          {{ tag.name }}
        </span>
      </div>
    </template>
  </SfDropdown>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import { useDropdown } from '@app/shared/pinia/dropdown'
import { dropdowns } from '@app/shared/vue/store/modules/dropdown/constants'
import { drawerDirections } from '@app/shared/vue/components/sf-dropdown/constants'
import useI18n from '@app/shared/vue/composables/use-I18n'

import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import { storeToRefs } from 'pinia'

const store = useStore()

const I18n = useI18n()

const dropdownStore = useDropdown()
const { toggleDropdown, closeDropdown } = useDropdown()
const { currentDropdownId } = storeToRefs(dropdownStore)

const tags = computed(() => store.state.remarkTags.workflowReviewTags)
const workflowReviewActiveTagId = computed(
  () => store.state.remarkTags.workflowReviewActiveTagId
)

const currentTag = computed(() =>
  tags.value.find((tag) => tag.id === workflowReviewActiveTagId.value)
)

const effectiveTags = computed(() =>
  tags.value.map((tag) => ({
    ...tag,
    activeClass:
      tag.id === workflowReviewActiveTagId.value ? 'sf-dim-el' : 'sf-pointer',
  }))
)

const isScopedDropdownOpen = computed(
  () => currentDropdownId.value === dropdowns.REVIEW_COMMS_FILTER
)

const showAllActiveClass = computed(() =>
  currentTag.value ? 'sf-pointer' : 'sf-dim-el'
)

const triggerText = computed(
  () =>
    `${I18n.t('companies_overview.filters.comparison_modes.tags')}: ${
      currentTag.value
        ? currentTag.value.name
        : I18n.t('companies_overview.filters.comparison_modes.any')
    }`
)

function clearTagSelection() {
  closeDropdown(dropdowns.REVIEW_COMMS_FILTER)
  store.dispatch('setWorkflowReviewActiveTag', null)
}

function handleToggleDropdown() {
  toggleDropdown(dropdowns.REVIEW_COMMS_FILTER)
}

function tagSelected(tag) {
  closeDropdown(dropdowns.REVIEW_COMMS_FILTER)
  store.dispatch('setWorkflowReviewActiveTag', tag)
}
</script>
